import React, { useEffect, useState } from 'react';
import API from '../api';
import Header from '../components/Header';
import PageHeading from '../components/PageHeading';
import Footer from '../components/Footer';
import PolaroidFrame from '../components/PolaroidFrame';
import styles from './Team.module.css';
import { useAuth } from '../contexts/AuthContext';

const Team = () => {
  const { user } = useAuth();
  const isAdmin = !!user && user.role === 'admin';
  const [members, setMembers] = useState([]);
  const [fullName, setFullName] = useState('');
  const [position, setPosition] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [dragIndex, setDragIndex] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');
  const [editPosition, setEditPosition] = useState('');
  const [editImageUrl, setEditImageUrl] = useState('');
  const [editImageFile, setEditImageFile] = useState(null);
  // Show admin controls always for clarity

  useEffect(() => {
    async function load() {
      try {
        const res = await API.get('/team');
        setMembers(res.data || []);
      } catch (_) {}
    }
    load();
  }, []);

  return (
    <div>
      <Header />
      <main style={{ padding: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '100vh' }}>
        <PageHeading title="Our Team" />
        {/* Meet the team text */}
        <div 
          className={styles.meetTheTeamText}
          style={{
            width: '100%',
            height: '53px',
            marginBottom: '100px',
            fontFamily: 'Bebas Neue',
            fontStyle: 'normal',
            fontWeight: '400',
            fontSize: '44px',
            lineHeight: '53px',
            letterSpacing: '0.05em',
            color: '#FFFFFF',
            paddingLeft: '2rem',
            position: 'relative',
            zIndex: 1
          }}
        >
          Meet the team
        </div>
        <section className={styles.teamSection}>
          {/* Tablet Team Layout */}
          <div className={styles.tabletTeamLayout}>
            {/* Administration */}
            <div className={styles.categoryAdmin}>ADMINISTRATION</div>
            <div className={styles.adminMember1}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.adminMember2}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>

            {/* Account Managers */}
            <div className={styles.categoryAccountMgrs}>ACCOUNT MANAGERS</div>
            <div className={styles.accountMember1}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.accountMember2}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.accountMember3}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>

            {/* Copywriters */}
            <div className={styles.categoryCopywriters}>COPYWRITERS</div>
            <div className={styles.copyMember1}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.copyMember2}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.copyMember3}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>

            {/* Public Relations */}
            <div className={styles.categoryPR}>PUBLIC RELATIONS</div>
            <div className={styles.prMember1}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.prMember2}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.prMember3}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>

            {/* Social Media */}
            <div className={styles.categorySocialMedia}>SOCIAL MEDIA</div>
            <div className={styles.socialMember1}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.socialMember2}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.socialMember3}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.socialMember4}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.socialMember5}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.socialMember6}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>

            {/* Visuals */}
            <div className={styles.categoryVisuals}>VISUALS</div>
            <div className={styles.visualMember1}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.visualMember2}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.visualMember3}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.visualMember4}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.visualMember5}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
            <div className={styles.visualMember6}>
              <div className={styles.memberName}>Name</div>
              <div className={styles.memberTitle}>TITLE</div>
            </div>
          </div>

          {/* Admin add member form */}
          {isAdmin && (
            <div style={{ marginTop: '2rem', width: '100%', maxWidth: 600 }}>
              <h3 style={{ color: '#fff', marginBottom: '1rem' }}>Add Team Member</h3>
              <div style={{ display: 'grid', gap: '0.75rem' }}>
                <input placeholder="Full name" value={fullName} onChange={e => setFullName(e.target.value)} />
                <input placeholder="Position" value={position} onChange={e => setPosition(e.target.value)} />
                <input placeholder="Image URL (optional if uploading)" value={imageUrl} onChange={e => setImageUrl(e.target.value)} />
                <input type="file" accept="image/*" onChange={e => setImageFile(e.target.files?.[0] || null)} />
                <button
                  className="btn btn-primary"
                  onClick={async () => {
                    const form = new FormData();
                    form.append('fullName', fullName);
                    form.append('position', position);
                    if (imageFile) form.append('image', imageFile);
                    if (imageUrl && !imageFile) form.append('imageUrl', imageUrl);
                    await API.post('/team', form, { headers: { 'Content-Type': 'multipart/form-data' } });
                    setFullName(''); setPosition(''); setImageUrl(''); setImageFile(null);
                    const res = await API.get('/team');
                    setMembers(res.data || []);
                  }}
                >Add Member</button>
              </div>
            </div>
          )}

        </section>
        {/* Video section (centered) */}
        <div className={styles.videoSection} style={{ width: '100%', justifyContent: 'center', margin: '2rem 0' }}>
          <div style={{ width: 'min(900px, 90vw)', aspectRatio: '16 / 9' }}>
            <iframe
              src="https://www.youtube.com/embed/eJ167rrVtdI"
              title="Team video"
              style={{ width: '100%', height: '100%', border: 0 }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
        {isAdmin && editingId && (
          <section style={{ marginTop: '2rem', width: '100%', maxWidth: 600 }}>
            <h3 style={{ color: '#fff', marginBottom: '1rem' }}>Edit Team Member</h3>
            <div style={{ display: 'grid', gap: '0.75rem' }}>
              <input placeholder="Full name" value={editName} onChange={e => setEditName(e.target.value)} />
              <input placeholder="Position" value={editPosition} onChange={e => setEditPosition(e.target.value)} />
              <input placeholder="Image URL (optional if uploading)" value={editImageUrl} onChange={e => setEditImageUrl(e.target.value)} />
              <input type="file" accept="image/*" onChange={e => setEditImageFile(e.target.files?.[0] || null)} />
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <button className="btn btn-primary" onClick={async () => {
                  const form = new FormData();
                  if (editName) form.append('fullName', editName);
                  if (editPosition) form.append('position', editPosition);
                  if (editImageFile) form.append('image', editImageFile);
                  if (editImageUrl && !editImageFile) form.append('imageUrl', editImageUrl);
                  await API.put(`/team/${editingId}`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
                  setEditingId(null);
                  const res = await API.get('/team');
                  setMembers(res.data || []);
                }}>Save</button>
                <button className="btn btn-secondary" onClick={() => setEditingId(null)}>Cancel</button>
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default Team;